/**
 * Created by why on 2020/3/15.
 */
const steps = [
  {
    element: '#hamburger-container',
    popover: {
      title: '折叠菜单',
      description: '打开和收缩菜单栏',
      position: 'bottom'
    }
  },
  {
    element: '#breadcrumb-container',
    popover: {
      title: '页面路径',
      description: '指示当前页位置',
      position: 'bottom'
    }
  },
  {
    element: '#screenfull',
    popover: {
      title: '全屏显示',
      description: '可实现全屏显示',
      position: 'left'
    }
  },
  {
    element: '#novice',
    popover: {
      title: '新手引导',
      description: '引导新手熟悉系统功能',
      position: 'left'
    }
  },
  {
    element: '#bug',
    popover: {
      title: '异常请求',
      description: '查看异常请求详情',
      position: 'left'
    }
  },
  {
    element: '#language',
    popover: {
      title: '语言设置',
      description: '可切换中文简体、中文繁体、English、日本語',
      position: 'left'
    }
  },
  {
    element: '#user',
    popover: {
      title: '用户栏',
      description: '包含用户信息设置、消息详情等',
      position: 'left'
    }
  },
  {
    element: '#tags-view-container',
    popover: {
      title: '菜单视图',
      description: '您访问的页面的历史记录',
      position: 'bottom'
    },
    padding: 0
  }
]

export default steps



// WEBPACK FOOTER //
// ./src/components/main/components/guide/steps.js